// Moment
import moment from "moment";
import "moment/locale/zh-hk";
import _ from "lodash";
export const CurrencyFormat = (value, decimal_places = 1) => {
  return (
    "$" +
    Number(value)
      .toFixed(decimal_places)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  );
};

export const toPercent = (value, decimal_places = 1) => {
  return `${new Intl.NumberFormat("en", {
    minimumFractionDigits: decimal_places,
  }).format(_.round(value, decimal_places))}%`;
};
export const numberFormat = (value) => {
  return value.toString().padStart(1, "0");
};

export const invoiceFormat = (value) => {
  return value.toString().padStart(5, "0");
};

export const invoiceTotal = (value) => {
  return parseInt(value.product_discount_total) !== 0 &&
    moment().isBetween(
      value.product_discount_startdate,
      value.product_discount_enddate
    )
    ? parseInt(value.product_discount_total)
    : parseInt(value.product_unit_total);
};

export const uuid = () => {
  var d = Date.now();
  if (
    typeof performance !== "undefined" &&
    typeof performance.now === "function"
  ) {
    d += performance.now(); //use high-precision timer if available
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};
